import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Homepage from "./pages/Homepage";
import AboutUs from "./pages/AboutUs";
import ContactUs from "./pages/ContactUs";
import TermLoans from "./pages/solutions/TermLoans";
import LinesOfCredit from "./pages/solutions/LinesOfCredit";
import EquipmentFinancing from "./pages/solutions/EquipmentFinancing";
import MerchantProcessing from "./pages/solutions/MerchantProcessing";
import ManagementSystems from "./pages/solutions/ManagementSystems";
import JumboTermLoan from "./pages/solutions/JumboTermLoan";
import HybridLOC from "./pages/solutions/HybridLOC";
import SBAGrocery from "./pages/solutions/SBAGrocery";
import SBAMadeInAmerica from "./pages/solutions/SBAMadeInAmerica";
import RealEstateFinancing from "./pages/solutions/RealEstateFinancing";
import Apply from "./pages/Apply";
import Partner from "./pages/Partner";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import BorrowerFunnel from "./pages/funnels/BorrowerFunnel";
import PartnerFunnel from "./pages/funnels/PartnerFunnel";
import TransportationFinance from "./pages/solutions/TransportationFinance";
import ForeclosureBailout from "./pages/solutions/ForeclosureBailout";
import AcademyHome from "./pages/academy/AcademyHome";
import ArticlePage from "./pages/academy/ArticlePage";
import CategoryPage from "./pages/academy/CategoryPage";
import SearchPage from "./pages/academy/SearchPage";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function AppRoutes() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith('/admin');
  const isFunnel = pathname.startsWith('/funnel');
  const hideChrome = isAdmin || isFunnel;

  return (
    <>
      <ScrollToTop />
      {!hideChrome && <Header />}
      <main className={!hideChrome ? "pt-20" : ""}>
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/solutions/term-loans" element={<TermLoans />} />
          <Route path="/solutions/lines-of-credit" element={<LinesOfCredit />} />
          <Route path="/solutions/equipment-financing" element={<EquipmentFinancing />} />
          <Route path="/solutions/merchant-processing" element={<MerchantProcessing />} />
          <Route path="/solutions/management-systems" element={<ManagementSystems />} />
          <Route path="/solutions/jumbo-term-loan" element={<JumboTermLoan />} />
          <Route path="/solutions/hybrid-loc" element={<HybridLOC />} />
          <Route path="/solutions/sba-grocery" element={<SBAGrocery />} />
          <Route path="/solutions/sba-made-in-america" element={<SBAMadeInAmerica />} />
          <Route path="/solutions/real-estate" element={<RealEstateFinancing />} />
          <Route path="/solutions/transportation-finance" element={<TransportationFinance />} />
          <Route path="/solutions/foreclosure-bailout" element={<ForeclosureBailout />} />
          <Route path="/academy" element={<AcademyHome />} />
          <Route path="/academy/search" element={<SearchPage />} />
          <Route path="/academy/category/:slug" element={<CategoryPage />} />
          <Route path="/academy/:slug" element={<ArticlePage />} />
          <Route path="/apply" element={<Apply />} />
          <Route path="/partner" element={<Partner />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/funnel/borrower" element={<BorrowerFunnel />} />
          <Route path="/funnel/partner" element={<PartnerFunnel />} />
        </Routes>
      </main>
      {!hideChrome && <Footer />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </div>
  );
}

export default App;
